<template>
  <ValidationObserver ref="observer">
  <v-row>
    <v-col cols="6" md="6">
      <ValidationProvider
              v-slot="{ errors }"
              :name="$t('HuifuAccount.Fields.reg_prov_id')"
              rules="required"
      >
        <v-autocomplete
          color="primary"
          hide-no-data
          v-model="provinceSelected"
          clearable
          :items="provinceItems"
          :loading="provincesLoading"
          :search-input.sync="provincesSearch"
          item-text="name"
          item-value="id"
          item-disabled="disabled"
          :label="$t('Area.city_1')"
          return-object
          :single-line="dense"
          :dense="dense"
          :hide-details="dense"
          :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
          :error-messages="errors"
        >
          <template v-slot:message="{ key, message }">
            <div :class="key == 0 ? 'danger--text' : ''">
              {{ message }}
            </div>
          </template>
        </v-autocomplete>
      </ValidationProvider>
    </v-col>
    <v-col cols="6" md="6">
      <ValidationProvider
              v-slot="{ errors }"
              :name="$t('HuifuAccount.Fields.reg_area_id')"
              rules="required"
      >
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="citySelected"
        clearable
        :items="cityItems"
        :loading="citiesLoading"
        :search-input.sync="citiesSearch"
        item-text="name"
        item-value="id"
        :label="$t('Area.city_2')"
        return-object
        :single-line="dense"
        :dense="dense"
        :hide-details="dense"
        :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
        :error-messages="errors"
      > <template v-slot:message="{ key, message }">
        <div :class="key == 0 ? 'danger--text' : ''">
          {{ message }}
        </div>
      </template>
      </v-autocomplete>
      </ValidationProvider>
    </v-col>
  </v-row>
  </ValidationObserver>
</template>
<script>
import HfdgInterface from "@/api/hfdgInterface";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "CitiesHFSelectGroup",

  components: {
    ValidationObserver,
    ValidationProvider,
  },

  props: {
    noLabel: Boolean,
    dense: Boolean,
    masterItem: Object,
  },

  data: () => ({
    provinceItems: [],
    cityItems: [],
    provinceItemsObj: null,
    cityItemsObj: null,
    provinceSelected: null,
    citySelected: null,
    provincesLoading: false,
    citiesLoading: false,
    provincesSearch: "",
    citiesSearch: "",
    provinceCode: null,
    cityCode: null,

  }),

  mounted() {
    //获取一级地址
    HfdgInterface.select({ rank: 1 }).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.provinceItemsObj = response.data.cities;
          this.provinceItems = response.data.cities;
        }
      }.bind(this)
    );
  },

  watch: {
    provinceItemsObj: {
      handler() {
        //默认选中已设置的一级地址
        if (this.masterItem.hfdg_province_id && this.provinceItemsObj) {
          this.provinceSelected = {
            id: this.masterItem.hfdg_province_id,
            code: this.masterItem.reg_prov_id
          };
        }
      },
    },
    provinceSelected: {
      handler() {
        if (this.provinceSelected && this.provinceSelected.id) {
          //同步选择的一级地址
          this.$emit("provinceCode", this.provinceSelected.code);
          //获取二级地址
          HfdgInterface.select({
            rank: 2,
            parent_city_id: this.provinceSelected.id,
          }).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.cityItemsObj = response.data.cities;
                this.cityItems = response.data.cities;
              }
            }.bind(this)
          );
        } else {
          this.$emit("provinceCode", null);
          this.cityItems = [];
          this.citySelected = null;
        }
      },
    },
    cityItems: {
      deep: true,
      handler() {
        if (this.cityItems) {
          //默认选中已设置的二级地址
          if (this.masterItem.hfdg_city_id && this.cityItemsObj) {
            this.citySelected = {
              id: this.masterItem.hfdg_city_id,
              code: this.masterItem.reg_area_id
            };
          }
        }
      },
    },
    citySelected: {
      handler() {
        if (this.citySelected && this.citySelected.id) {
          //同步选择的二级地址
          this.$emit("cityCode", this.citySelected.code);
        } else {
          this.$emit("cityCode", null);
        }
      },
    },
  },
};
</script>